<div class="row mb-row">
  <!-- <div class="col-sm-12" *ngIf="!suggeritiFound || suggeritiFound.length === 0">
    <h5>Nessun soggetto suggerito</h5>
  </div> -->
  <div class="col-sm-12 mb-row p-row" *ngIf="altreParti && altreParti.length > 0">
    <p>Soggetti terzi associati: </p>
    <step-soggetti-terzi-list-altreparti 
      [sezione]="sezione"
      [fascicolo]="fascicolo"
      (onDocumentEvent)="onDocumentEvent($event)"
      (onEditAltraParte)="retrieve($event)" 
      (onDropDownEvent)="onDropDownEvent($event)" 
      (onDelete)="onDeleteAltraParte($event)" 
      [associable]="false" 
      [labelComponent]="'altreparti'" 
      [action] = "action" 
      (actionEmitter)="action = $event">
    </step-soggetti-terzi-list-altreparti>
  </div>
  <div class="col-sm-12" *ngIf="suggeritiFound && suggeritiFound.length > 0">
    <h5>Soggetti terzi suggeriti :</h5>
    <step-soggetti-terzi-list [associable]="true" [labelComponent]="'suggested'" [action] = "action" (actionEmitter)="action = $event" [soggetti]="suggeritiFound"></step-soggetti-terzi-list>
  </div>
</div>

<div class="row">
  <div class="col-sm-12">
    <div class="container_tab_nav">

      <!-- Tablist -->
      <ul class="nav nav-tabs two" role="tablist" aria-label="Gestione soggetti terzi">
        <li class="tab-link-nav" [style.width.%]="50">
          <button
            type="button"
            role="tab"
            id="tab-0-sogg"
            class="btn-link"
            [attr.aria-selected]="activeTab === 0"
            [attr.aria-controls]="'tabpanel-0-sogg'"
            [class.active]="activeTab === 0"
            [class.inactive]="activeTab !== 0"
            (click)="activeTab = 0"
          >
            Cerca
          </button>
        </li>

        <li class="tab-link-nav"  [style.width.%]="50">
          <button
            type="button"
            role="tab"
            id="tab-1-sogg"
            class="btn-link"
            [attr.aria-selected]="activeTab === 1"
            [attr.aria-controls]="'tabpanel-1'"
            [class.active]="activeTab === 1"
            [class.inactive]="activeTab !== 1"
            (click)="activeTab = 1"
          >
            Inserisci
          </button>
        </li>
      </ul>

      <!-- Tab panels -->
      <div class="tab-content">

        <!-- Pannello Cerca -->
        <div
          role="tabpanel"
          id="tabpanel-0-sogg"
          [attr.aria-labelledby]="'tab-0-sogg'"
          [hidden]="activeTab !== 0"
          class="tab-pane fade"
          [class.active]="activeTab === 0"
          [class.in]="activeTab === 0"
        >
          <div
            searchTextInput
            #searchElement
            [url]="requestSearchUrl"
            (onReturn)="retrieveSearch($event)"
            (keyup)="onSearchChange(searchElement.valueSearch)"
          ></div>

          <div class="col-sm-12" *ngIf="foundElements && foundElements.length > 0">
            <h5>Risultati:</h5>
            <step-soggetti-terzi-list
              (emitAltraParte)="retrieveAltraParte($event)"
              [associable]="true"
              [labelComponent]="'found'"
              [action]="action"
              (actionEmitter)="action = $event"
              [soggetti]="foundElements"
              (emitParte)="retrieveParte($event)"
              (parteChange)="onEmitSearch($event)"
              [totali]="totalResults"
              (requestMore)="reloadSearch()"
            >
            </step-soggetti-terzi-list>
          </div>

          <p *ngIf="hasSearched && foundElements.length == 0">Nessuna parte trovata.</p>
        </div>

        <!-- Pannello Inserisci -->
        <div
          role="tabpanel"
          id="tabpanel-1"
          [attr.aria-labelledby]="'tab-1-sogg'"
          [hidden]="activeTab !== 1"
          class="tab-pane fade"
          [class.active]="activeTab === 1"
          [class.in]="activeTab === 1"
        >
          <step-soggetti-terzi-form
            [parte]="parte"
            (onParteReturn)="onParteInsert($event)"
            (altraParteChange)="retrieveNewSoggettoTerzo($event)"
          ></step-soggetti-terzi-form>
        </div>

      </div>
    </div>
  </div>
</div>


<div [attr.id]="'docAddModalAltreParti'" style="width: 100%;height: 100vh;margin: 0px;" doc_add_modal #docAddModalAltreParti [fascicolo]="this.fascicolo"
  (onReturn)="closeModalDocumentAndReadSezione()"></div>

<div doc_version_update_modal  #docVersionUpdateModalAltreParti [attr.id]="'docVersionUpdateModalAltreParti'" [fascicolo]="fascicolo" (onReturn)="closeModalDocumentAndReadSezione()" style="width: 80%;"></div>

<div doc_version_history_modal #docVersionHistoryAltreParti [tipoPratica]="fascicolo?.praticaBase?.tipoPratica.id" [attr.id]="'docVersionHistoryAltreParti'"></div>


<!-- <div class="row wizard-buttons">
  <p class="col-sm-3 col-xs-6">
    <button type="button" class="btn btn-outline-secondary btn-block" (click)="reset()">Reset</button>
  </p>
  <p
    class="col-sm-3 col-xs-6 col-sm-offset-6">
    <button type='button' class='btn btn-primary btn-block'  (click)="salva()">
      Salva
    </button>
  </p>
</div> -->
